/**
 * Contrats de jeu transverses (voir docs/specs/00 §4-5 et docs/specs/02).
 * ⚠️ Aucun type de payload sortant vers un client ne doit contenir de donnée
 * secrète (ADR 0003). Les types spécifiques par jeu vivent sous src/games/<jeu>/.
 */

/** Slug identifiant un jeu (le hub et l'historique s'y réfèrent). */
export type GameSlug = 'motus' | 'motus-daily' | 'griffonne' | 'panda-panic';

/**
 * Libellés humains des jeux (hub, historique, parties en cours). Les slugs et
 * routes ne changent JAMAIS pour un renommage d'affichage (ADR 0011 §6).
 * `panda-panic` = slug écrit par l'API en fin de partie en ligne (spec 15 §5,
 * Phase 5) — cf. `PANDA_PANIC_SLUG`.
 */
export const GAME_LABELS: Record<GameSlug, string> = {
  motus: 'Motus duel',
  'motus-daily': 'Motus du jour',
  griffonne: 'Griffonne',
  'panda-panic': 'Panda Panic',
};

/** Libellé d'affichage d'un jeu ; repli sur le slug si inconnu (donnée historique). */
export function gameLabel(slug: string): string {
  return GAME_LABELS[slug as GameSlug] ?? slug;
}

/** États génériques d'une partie (machine à états du socle). */
export type MatchStatus = 'waiting' | 'active' | 'finished' | 'aborted';

/** Résultat d'un joueur dans une partie (alimente le profil/historique). */
export type MatchResult = 'win' | 'loss' | 'draw' | 'abandon';

/** Bornes de longueur d'un mot MOTUS (la longueur est dérivée du mot choisi). */
export const MOTUS_MIN_LENGTH = 5 as const;
export const MOTUS_MAX_LENGTH = 12 as const;

/** Vrai si `n` est une longueur de mot MOTUS autorisée. */
export function isValidMotusLength(n: number): boolean {
  return Number.isInteger(n) && n >= MOTUS_MIN_LENGTH && n <= MOTUS_MAX_LENGTH;
}
